import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../style/Blog.css';

const Navbar = () => {
  const { user, logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const pathname = location.pathname;

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const isHomePage = pathname === '/';
  const isLoginPage = pathname === '/login';
  const isRegisterPage = pathname === '/register';
  const isMyPostsPage = pathname === '/profile/posts';
  const isBlogFormPage = pathname === '/posts/new';
  const isProfilePage = pathname === '/profile';

  return (
    <nav className="navbar sticky-top">
      <div className="container d-flex justify-content-between align-items-center py-3">
        {/* Post App icon with window styling */}
        <div
          className="retro-window navbar-window"
          style={{ marginLeft: '-15px', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <button
            className="d-flex flex-column align-items-start text-dark fs-4 text-decoration-none"
            style={{ background: 'none', border: 'none', textShadow: '2px 2px #fff' }}
          >
            <div className="window-dots">
              <span className="dot red" />
              <span className="dot yellow" />
              <span className="dot green" />
            </div>
            <span className="fw-bold">Post App</span>
          </button>
        </div>

        {/* Desktop buttons */}
        <div className="d-none d-md-flex flex-wrap gap-3 align-items-center justify-content-end ms-auto">
          {!isHomePage && (
            <Link to="/" className="retro-button px-3 py-2">Home</Link>
          )}
          {user && !isMyPostsPage && (
            <Link to="/profile/posts" className="retro-button px-3 py-2">My Posts</Link>
          )}
          {user && !isHomePage && !isBlogFormPage && (
            <Link to="/posts/new" className="retro-button px-3 py-2">+ Create New Post</Link>
          )}
          {user && !isProfilePage && ( // Profile button only if not already on the profile page
            <Link to="/profile" className="retro-button px-3 py-2">Profile</Link>
          )}
          {!user && !isHomePage && (
            <>
              {!isLoginPage && (
                <Link to="/login" className="retro-button px-3 py-2">Login</Link>
              )}
              {!isRegisterPage && (
                <Link to="/register" className="retro-button px-3 py-2">Register</Link>
              )}
            </>
          )}
          {user && (
            <button
              className="retro-button px-3 py-2"
              onClick={handleLogout}
            >
              Logout
            </button>
          )}
        </div>

        {/* Hamburger Toggle (moved to right with wrapper) */}
        {!isHomePage && (
          <div className="hamburger-wrapper d-md-none">
            <button
              className="retro-button px-3 py-2"
              onClick={() => setMenuOpen(prev => !prev)}
            >
              ☰
            </button>

            {/* Floating Mobile Menu */}
            {menuOpen && (
              <div className="floating-menu">
                {!isHomePage && (
                  <Link to="/" className="retro-button w-100 mb-2" onClick={() => setMenuOpen(false)}>Home</Link>
                )}
                {user && !isMyPostsPage && (
                  <Link to="/profile/posts" className="retro-button w-100 mb-2" onClick={() => setMenuOpen(false)}>My Posts</Link>
                )}
                {user && !isBlogFormPage && (
                  <Link to="/posts/new" className="retro-button w-100 mb-2" onClick={() => setMenuOpen(false)}>+ Create New Post</Link>
                )}
                {user && !isProfilePage && ( // Profile button in mobile menu
                  <Link to="/profile" className="retro-button w-100 mb-2" onClick={() => setMenuOpen(false)}>Profile</Link>
                )}
                {!user && (
                  <>
                    {!isLoginPage && (
                      <Link to="/login" className="retro-button w-100 mb-2" onClick={() => setMenuOpen(false)}>Login</Link>
                    )}
                    {!isRegisterPage && (
                      <Link to="/register" className="retro-button w-100 mb-2" onClick={() => setMenuOpen(false)}>Register</Link>
                    )}
                  </>
                )}
                {user && (
                  <button
                    className="retro-button w-100"
                    onClick={() => {
                      setMenuOpen(false);
                      handleLogout();
                    }}
                  >
                    Logout
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
